// extracted by mini-css-extract-plugin
module.exports = {"small":"ModalSmall_small__SP3Wq"};